import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _taggedTemplateLiteral from '../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { forwardRef, useState, useRef, useLayoutEffect } from 'react';
import 'prop-types';
import { jsx, css } from '@emotion/core';
import Input from './Input.js';
import btnReset from '../../utils/styles.js';
import forms from '../../styles/forms.js';
import { dlsBrightBlue } from '../../styles/colorsDls/dlsBrightBlue.js';
import { useThemeContext } from '../ThemeProvider/ThemeContext.js';

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var PasswordInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var defaultShow = props.defaultShow,
      hideButton = props.hideButton,
      showLabel = props.showLabel,
      hideLabel = props.hideLabel,
      otherProps = _objectWithoutProperties(props, ["defaultShow", "hideButton", "showLabel", "hideLabel"]);

  var _useState = useState(defaultShow),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      clicked = _useState4[0],
      setClicked = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      inputPaddingOffset = _useState6[0],
      setInputPaddingOffset = _useState6[1];

  var inputRef = ref || useRef(null);
  var buttonRef = useRef(null);
  var themeTokens = useThemeContext();
  useLayoutEffect(function () {
    var selectionStart = inputRef.current.selectionStart;

    if (clicked) {
      inputRef.current.focus();
      inputRef.current.setSelectionRange(selectionStart, selectionStart);
    }
  }, [show, clicked, inputRef]);
  useLayoutEffect(function () {
    if (!hideButton) {
      var buttonWidth = buttonRef.current.getBoundingClientRect().width;
      setInputPaddingOffset(buttonWidth);
    }
  }, [buttonRef, show, hideButton]);
  /**
   * Sets the state to show and hide the password
   */

  var handlePasswordButtonClick = function handlePasswordButtonClick() {
    setShow(function (previousShow) {
      return !previousShow;
    });
    if (!clicked) setClicked(true);
  };

  var buttonStyle = _objectSpread(_objectSpread(_objectSpread({}, btnReset), forms.btnForm), {}, {
    color: themeTokens.primaryColor || dlsBrightBlue.color
  });

  return jsx(Input, _extends({
    type: show && !hideButton ? 'text' : 'password',
    ref: inputRef,
    css: !hideButton ? css(_templateObject || (_templateObject = _taggedTemplateLiteral(["input { padding-right: ", "px }"])), inputPaddingOffset) : ''
  }, otherProps), !hideButton && jsx("button", {
    css: buttonStyle,
    type: "button",
    onClick: handlePasswordButtonClick,
    ref: buttonRef
  }, show ? hideLabel : showLabel));
});
PasswordInput.displayName = 'PasswordInput';
PasswordInput.defaultProps = {
  defaultShow: false,
  hideButton: false,
  showLabel: 'Show',
  hideLabel: 'Hide'
};

export default PasswordInput;
